import type { SetPasswordState } from '@/scopes/auth/domain/types'

export function getIsSubmitDisabled(state: SetPasswordState) {
  return state.submitStatus === 'loading' || state.pageInitializationStatus !== 'success'
}

export function getIsPageInitializing(state: SetPasswordState) {
  return state.pageInitializationStatus === 'idle' || state.pageInitializationStatus === 'loading'
}
